<template>
  <div class="token-body">
    <div class="token-table">
      <div class="table-title">代币列表</div>
      <ul class="table-header">
        <li
          v-for="(item, index) in tokenDataHeader"
          :key="index"
          class="table-header-li"
        >
          {{ item }}
        </li>
      </ul>
      <ul class="table-body" v-if="tokenData && tokenData.length > 0">
        <li
          v-for="(item, index) in tokenData"
          :key="index"
          class="table-body-li"
        >
          <div class="table-body-text">
            {{ item.contractAddress | addressEll }}
          </div>
          <div class="table-body-text">{{ item.name }}</div>
          <div class="table-body-text">{{ item.symbol }}</div>
          <div class="table-body-text">
            {{ item.template | getNameWithMode }}
          </div>
          <div class="table-body-text">
            {{ item.chainId | getNameWithChainId }}
          </div>
          <div class="table-body-text">{{ item.owner | addressEll }}</div>
          <div class="table-body-text">{{ item.createTime | formatTime }}</div>
          <div class="table-body-btn">
            <div
              @click="handleDeploy(item)"
              class="btn-deploy"
              v-if="item.status == 1"
            >
              发布
            </div>
            <div @click="handleManage(item)" class="btn-manage">查看</div>
            <div @click="handleDelete(item)" class="btn-delete">删除</div>
          </div>
        </li>
      </ul>
      <div class="table-body-noData" v-if="!tokenData || tokenData.length == 0">
        暂无数据
      </div>
      <el-pagination
        v-if="tokenData && tokenData.length > 0"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { consoleQuery, consoleDelete } from "@/config/api.js";
export default {
  data() {
    return {
      tokenDataHeader: [
        "合约",
        "名称",
        "简称",
        "类型",
        "链",
        "所有者",
        "时间",
        "操作",
      ],
      tokenData: null,
      page: 1,
      total: 0,
      account: "",
    };
  },
  beforeMount() {
    if (localStorage.getItem("TokenBox-account")) {
      this.account = localStorage.getItem("TokenBox-account");
      this.requestConsoleQuery();
    }
  },
  methods: {
    handleDeploy(item) {
      var data = [
        { code: "base", path: "/stardand" },
        { code: "freeMint", path: "/greeMint" },
        { code: "dividend", path: "/holdReflection" },
        { code: "lpDividend", path: "/LPReflection" },
        { code: "lpWithInviter", path: "/LPWithInviter" },
      ];
      var res = data.filter((ele) => ele.code == item.template);
      if (res && res.length > 0) {
        if (this.account != item.owner) {
          return;
        }
       
      if (item.chainId != localStorage.getItem("TokenBox-chainID")) {
         this.$message.warning("当前网络与合约发布记录不一致,请先切换网络");
         return
      }
        
        this.$router.push({
          path: res[0].path,
          query: {contractId: item.contractId, hash:item.hash},
        });
      } else {
        this.$message.warning("暂不支持该类型合约发布");
      }
    },
    handleManage(item) {
       if (item.chainId != localStorage.getItem("TokenBox-chainID")) {
         this.$message.warning("当前网络与合约发布记录不一致,请先切换网络");
         return
      }
      this.$router.push({
        path: "/contractDetail",
        query: { contractId: item.contractId, mode: item.template },
      });
    },
    async handleDelete(item) {
      var data = {
        contractId: item.contractId,
      };
      var res = await consoleDelete(JSON.stringify(data));

      if (res&&res.data) {
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.requestConsoleQuery();
      }
    },
    async requestConsoleQuery() {
      var data = {
        owner: this.account,
        page: this.page,
        size: 10,
      };
      var res = await consoleQuery(data);
      if (res&&res.data) {
        this.total = res.data.total;
        this.tokenData = res.data.data;
      }
    },
    handleSizeChange(val) {
      // this.requestConsoleQuery();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.requestConsoleQuery();
    },
  },
};
</script>

<style lang="scss" scoped>
.token-body {
  width: calc(100% - 16%);
  height: 100%;
  background: #1f1f1f;
  border-radius: 20px 20px 20px 20px;

  padding: 0 8% 0 8%;
  .token-table {
    width: 100%;
    height: 100%;

    .table-title {
      font-weight: normal;
      font-size: 20px;
      color: #8f8f8f;
      line-height: 23px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin: 54px 0 0 0;
    }

    .table-header {
      width: calc(100% - 24px);
      height: 40px;

      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 54px 0 0 0;
      padding: 0 12px 0 12px;
      border-bottom: 1px solid #4d4d4d;
      li:nth-last-child(1) {
          min-width: 160px;
      }

      .table-header-li {
        width: 100%;

        font-weight: normal;
        font-size: 18px;
        color: #8f8f8f;
        line-height: 21px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }

    .table-body {
      width: 100%;
      height: calc(100% - 312px);
      overflow: auto;

      margin: 20px 0 20px 0;

      .table-body-li {
        width: calc(100% - 24px);
        height: 60px;
        background: #292929;
        border-radius: 8px 8px 8px 8px;
        margin: 0 0 8px 0;
        padding: 0 12px 0 12px;
        display: flex;
        align-items: center;

        .table-body-text {
          width: 100%;
          height: 100%;

          font-weight: normal;
          font-size: 15px;
          color: #c8c8c8;
          line-height: 60px;
          text-align: center;
          font-style: normal;
          text-transform: none;

          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        

        .table-body-btn {
          width: 100%;
          height: 100%;
          min-width: 160px;
         
          display: flex;
          justify-content: center;
          align-items: center;

          font-weight: normal;
          font-size: 14px;
          line-height: 60px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          white-space: nowrap;

          cursor: pointer;
          .btn-deploy {
            margin: 0 10px;
            color: rgb(51, 165, 6);
          }
          .btn-manage {
            margin: 0 10px;
            color: rgb(121, 109, 245);
          }

          .btn-delete {
            margin: 0 10px;
            color: rgb(170, 168, 168);
          }
        }

        // .table-body-btn:hover {
        //   background: rgba(77, 77, 77, 0.5);
        //   color: #d8d8d8;
        // }
      }
    }

    .table-body-noData {
      width: 100%;
      height: calc(100% - 312px);
      overflow: auto;

      margin: 20px 0 20px 0;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #675aff;
    }
  }
}

/* 为所有滚动条设置样式 */
::-webkit-scrollbar {
  width: 6px; /* 设置滚动条的宽度 */
  height: 10px; /* 设置滚动条的高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: transparent; /* 设置轨道的背景颜色 */
}

/* 滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background: #888; /* 设置滑块的背景颜色 */
  border-radius: 5px 5px;
}

/* 当鼠标悬停在滑块上 */
::-webkit-scrollbar-thumb:hover {
  background: #555; /* 设置滑块在悬停状态下的背景颜色 */
  cursor: pointer;
}
</style>